import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';

import useMobileLayout from 'Hooks/useMobileLayout';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useBoneBackgroundColor from 'Hooks/useBoneBackgroundColor';
import { CoverImage } from './CoverImage';

const useStyles = buildUseStyles('AuthenticationLayout', () => ({
  root: {
    display: 'flex',
    height: '100vh',
    width: '100vw',
  },
  rootDesktop: {
  },
  rootMobile: {
    display: 'flex',
    justifyContent: 'center',
  },
}));

export const AuthenticationLayout = ({ children }) => {
  const isMobile = useMobileLayout();
  const classes = useStyles();
  useBoneBackgroundColor();

  return (
    <Box
      className={classNames(classes.root, {
        [classes.rootMobile]: isMobile,
        [classes.rootDesktop]: !isMobile,
      })}
    >
      {children}
      {!isMobile && <CoverImage />}
    </Box>
  );
};

AuthenticationLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
};
